import template from './progress-chart.html';

export default class ProgressChartComponent {
  constructor() {
    this.bindings = {
      value: '<',
      type: '@',
    };

    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/progress-chart/progress-chart-component.js